
export default function(...actors) {
    return (next) => (reducer, initialState) => {
        const store = next(reducer, initialState)
        var state
        var acting = false

        store.subscribe(() => {
            const nextState = store.getState()

            if (nextState != state) {
                if (!acting) {
                    acting = true
                    actors.forEach((actor) => {
                        actor(store.getState(), store.dispatch)
                    })
                    acting = false
                }
            }
            state = nextState
        })

        return store
    }
}


// WEBPACK FOOTER //
// ./lib/core/redux/applyActor.js